module.exports = __webpack_public_path__ + "img/notfound.9d04a6aa.svg";